
    import './styles.scoped.css';
    export default {
  "appbar": "awsui_appbar_hyvsj_1of34_5",
  "appbar-nav": "awsui_appbar-nav_hyvsj_1of34_29",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_1of34_33",
  "appbar-tools": "awsui_appbar-tools_hyvsj_1of34_37",
  "background": "awsui_background_hyvsj_1of34_120",
  "content": "awsui_content_hyvsj_1of34_140",
  "layout": "awsui_layout_hyvsj_1of34_200",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_1of34_359",
  "container": "awsui_container_hyvsj_1of34_363",
  "unfocusable": "awsui_unfocusable_hyvsj_1of34_449",
  "navigation-container": "awsui_navigation-container_hyvsj_1of34_453",
  "show-navigation": "awsui_show-navigation_hyvsj_1of34_477",
  "animating": "awsui_animating_hyvsj_1of34_499",
  "showButtons": "awsui_showButtons_hyvsj_1of34_1",
  "navigation": "awsui_navigation_hyvsj_1of34_453",
  "openNavigation": "awsui_openNavigation_hyvsj_1of34_1",
  "animated-content": "awsui_animated-content_hyvsj_1of34_559",
  "hide-navigation": "awsui_hide-navigation_hyvsj_1of34_568",
  "notifications": "awsui_notifications_hyvsj_1of34_574",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_1of34_627",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_1of34_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_1of34_692",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_1of34_1",
  "tools-container": "awsui_tools-container_hyvsj_1of34_756",
  "tools": "awsui_tools_hyvsj_1of34_756",
  "openTools": "awsui_openTools_hyvsj_1of34_1",
  "hide-tools": "awsui_hide-tools_hyvsj_1of34_852",
  "show-tools": "awsui_show-tools_hyvsj_1of34_863",
  "trigger": "awsui_trigger_hyvsj_1of34_916"
};
  